import { AfterViewInit, Component, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { OrderManagerService, ValidationProblem, ValidationService } from 'reg-hub-common';
import { BaseHistoricalLienDetailsComponent } from '../base-historical-lien-details.component';
import { FormBuilder, FormGroup } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';
import { MatRadioChange } from '@angular/material/radio';

@Component({
    selector: 'app-historical-mb-lien-details',
    templateUrl: './historical-mb-lien-details.component.html',
    styleUrls: ['./historical-mb-lien-details.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class HistoricalMBLienDetailsComponent extends BaseHistoricalLienDetailsComponent {
  perfectionInAnotherJurisdictionError$ = new BehaviorSubject<string | null | undefined>(null);
  purchaseMoneySecurityInterestError$ = new BehaviorSubject<string | null | undefined>(null);
  receiverAppointmentError$ = new BehaviorSubject<string | null | undefined>(null);
  hasDebtorAcknowledgedError$ = new BehaviorSubject<string | null | undefined>(null);
  natureOfServiceRenderedError$ = new BehaviorSubject<string | null | undefined>(null);
  stillHavePossessionError$ = new BehaviorSubject<string | null | undefined>(null);
  surrenderDateError$ = new BehaviorSubject<string | null | undefined>(null);
  serviceLastRenderedError$ = new BehaviorSubject<string | null | undefined>(null);

  constructor(
    formBuilder: FormBuilder,
    orderManager: OrderManagerService,
    validationService: ValidationService) {
    super(formBuilder, orderManager, validationService);
  }

  public override pushErrors(errors: ValidationProblem[] | undefined): void {
    super.pushErrors(errors);

    this.perfectionInAnotherJurisdictionError$.next(errors?.filter(error => error.path.includes('perfection'))?.at(0)?.userFriendlyMessage);
    this.purchaseMoneySecurityInterestError$.next(errors?.filter(error => error.path.includes('purchaseMoneySecurityInterest'))?.at(0)?.userFriendlyMessage);
    this.receiverAppointmentError$.next(errors?.filter(error => error.path.includes('receiverAppointment'))?.at(0)?.userFriendlyMessage);
    this.hasDebtorAcknowledgedError$.next(errors?.filter(error => error.path.includes('hasdebtoracknowledged'))?.at(0)?.userFriendlyMessage);
    this.natureOfServiceRenderedError$.next(errors?.filter(error => error.path.includes('natureofservicerendered'))?.at(0)?.userFriendlyMessage);
    this.stillHavePossessionError$.next(errors?.filter(error => error.path.includes('stillhavepossession'))?.at(0)?.userFriendlyMessage);
    this.surrenderDateError$.next(errors?.filter(error => error.path.includes('surrenderdate'))?.at(0)?.userFriendlyMessage);
    this.serviceLastRenderedError$.next(errors?.filter(error => error.path.includes('servicelastrendered'))?.at(0)?.userFriendlyMessage);
  }

  protected override buildForm(): FormGroup {
    var form = this.formBuilder.group({}) as FormGroup;

    if (this.uiConfiguration.lienDetailsConfiguration?.showAmount) {
      form.addControl('amount', this.formBuilder.control(this.order.lien?.amount));
    }

    if(this.uiConfiguration.lienDetailsConfiguration?.showHasDebtorAcknowledged) {
      form.addControl('hasDebtorAcknowledged', this.formBuilder.control(this.order.lien?.hasDebtorAcknowledged ?? false));
    }

    if (this.uiConfiguration.lienDetailsConfiguration?.showTrustIndenture) {
      form.addControl('trustIndenture', this.formBuilder.control(this.order.lien?.trustIndenture ?? false));
    }

    if (this.uiConfiguration.lienDetailsConfiguration?.showPerfectionInAnotherJurisdiction) {
      form.addControl('perfectionInAnotherJurisdiction', this.formBuilder.control(this.order.lien?.perfectionInAnotherJurisdiction ?? false));
    }

    if (this.uiConfiguration.lienDetailsConfiguration?.showPurchaseMoneySecurityInterest) {
      form.addControl('purchaseMoneySecurityInterest', this.formBuilder.control(this.order.lien?.purchaseMoneySecurityInterest ?? false));
    }

    if (this.uiConfiguration.lienDetailsConfiguration?.showReceiverAppointment) {
      form.addControl('receiverAppointment', this.formBuilder.control(this.order.lien?.receiverAppointment ?? false));
    }

    if(this.uiConfiguration.lienDetailsConfiguration?.showNatureOfServiceRendered) {
      form.addControl('natureOfServiceRendered', this.formBuilder.control(this.order.lien?.natureOfServiceRendered));
    }

    if (this.uiConfiguration.lienDetailsConfiguration?.showAdditionalInformation) {
      form.addControl('additionalInformation', this.formBuilder.control(this.order.lien?.additionalInformation));
    }

    if (this.uiConfiguration.lienDetailsConfiguration?.showStillHavePossession) {
      form.addControl('stillHavePossession', this.formBuilder.control(this.order.lien?.stillHavePossession));
    }

    if (this.uiConfiguration.lienDetailsConfiguration?.showServiceLastRendered) {
      form.addControl('serviceLastRendered', this.formBuilder.control(this.order.lien?.serviceLastRendered));
    }

    if (this.uiConfiguration.lienDetailsConfiguration?.showSurrenderDate) {
      form.addControl('surrenderDate', this.formBuilder.control(this.order.lien?.surrenderDate));
    }

    return form;
  }
}